import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const OverlapCount = styled.text`
  font-size: 10px;
  font-weight: 700;
  fill: #333333;
  text-anchor: middle;
  dominant-baseline: central;
`;

const OverlapIcon = ({ count }) => {
  // Generate unique mask ID to avoid conflicts when multiple instances are rendered
  const maskId = useMemo(
    () => `backSquareMask-${Math.random()
      .toString(36)
      .slice(2, 11)}`,
    [],
  );

  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      {/* Define mask to hide overlapping portion of back square */}
      <defs>
        <mask id={maskId}>
          {/* White shows, black hides - show everything except front square area */}
          <rect x='0' y='0' width='20' height='20' fill='white' />
          <rect x='6' y='2' width='12' height='12' rx='2' fill='black' />
        </mask>
      </defs>
      {/* Back square - bottom left, masked to hide overlap area */}
      <rect
        x='2'
        y='6'
        width='12'
        height='12'
        rx='2'
        stroke='currentColor'
        strokeWidth='1.5'
        fill='none'
        mask={`url(#${maskId})`}
      />
      {/* Front square - top right, transparent and covers the overlap */}
      <rect
        x='6'
        y='2'
        width='12'
        height='12'
        rx='2'
        stroke='currentColor'
        strokeWidth='1.5'
        fill='none'
      />
      {/* Number inside front square with white stroke for visibility */}
      <OverlapCount x='12' y='8'>
        {count}
      </OverlapCount>
    </svg>
  );
};

OverlapIcon.propTypes = {
  count: PropTypes.number.isRequired,
};

export default OverlapIcon;
